<template>
  <div
    class="tw-flex tw-w-full tw-max-w-full tw-cursor-pointer tw-items-center tw-text-grey-medium hover:tw-text-blackest"
  >
    <div class="tw-flex tw-items-center tw-gap-2 tw-truncate tw-text-xs">
      <div
        v-if="status === 'Blacklisted'"
        v-tooltip="{
          content: statusTooltip,
          placement: 'top',
        }"
        class="tw-inline-block tw-rounded tw-bg-status-error tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        Blocked
      </div>
      <div
        v-else-if="status === 'Whitelisted'"
        v-tooltip="{
          content: statusTooltip,
          placement: 'top',
        }"
        class="tw-inline-block tw-rounded tw-bg-status-success tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        Allowed
      </div>
      <div
        v-else
        v-tooltip="{
          content: statusTooltip,
          placement: 'top',
        }"
        class="tw-inline-block tw-rounded tw-bg-status-archived tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        Pending
      </div>
    </div>
  </div>
</template>
<script>
import ListCellDefault from '@/components/list/cell/default.vue'

export default {
  name: 'ListCellCreativeStatusComputed',
  extends: ListCellDefault,
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      if (this.item.status === 'Whitelisted') {
        return 'Whitelisted'
      }

      if (this.item.status === 'Blacklisted') {
        return 'Blacklisted'
      }

      if (this.item.statusAi === 'Whitelisted') {
        return 'Whitelisted'
      }

      if (this.item.statusAi === 'Blacklisted') {
        return 'Blacklisted'
      }

      return 'Pending'
    },
    statusTooltip() {
      if (this.item.status === 'Whitelisted') {
        return 'The creative has been manually approved.'
      }

      if (this.item.status === 'Blacklisted') {
        return 'The creative has been manually blocked.'
      }

      if (this.item.statusAi === 'Whitelisted') {
        return 'The creative has been automatically approved by our AI.'
      }

      if (this.item.statusAi === 'Blacklisted') {
        return 'The creative has been automatically blocked by our AI.'
      }

      return 'The creative has not yet been processed by our AI or by a user.'
    },
  },
}
</script>
